module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_Foamcore_MockedUp.9fe8b386.jpg";